export default "__VITE_ASSET__sFjCQtZl__"